module.exports = __webpack_public_path__ + "arrow.66b3c0a7b40312aa950f3f165bf3c637.svg";